import styled from "styled-components";
import { FieldError } from "react-hook-form";
import { FormFieldWithError } from "../field-error/field-error.styles";
import { zIndex } from "styles";
import { SelectProps } from "./search-select.types";

export const StyledSearchInput = styled.input<
  SelectProps<Record<string, string | boolean>> & { error?: FieldError }
>`
  width: 100%;
  height: 40px;
  border: 2px solid
    ${({ theme, error }) => {
      return error?.message
        ? theme.colors.red[100]
        : theme.colors.periwinkle[500];
    }};
  box-sizing: border-box;
  border-radius: 6px;
  padding: 0 8px;
  position: relative;
  appearance: none;
  &:focus {
    outline: none;
  }
`;

export const SearchSelectInputWrapper = styled.div`
  position: relative;
`;

export const SearchSelectIcon = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  color: ${({ theme }) => theme.colors.neutral["500"]};
`;
export const SelectDiv = styled(FormFieldWithError)`
  padding: 8px 0px;
`;

export const StyledOption = styled.div`
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral["100"]};
`;

export const OptionContainer = styled.div`
  border: ${({ theme }) => theme.colors.neutral["600"]};
  max-height: 200px;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
  z-index: ${zIndex.dropdownList};
  background-color: ${({ theme }) => theme.colors.white};
`;
